/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import Base from '../Base/index';
import Resource from '../Resource/index';

/*
* 打谱
*/
// createJs 对象
const cjs = window.createjs;
// 不考虑分支情况，所以默认取第一个分支作为主分支
export default class Score {
  constructor(props) {
    this.options = {
      ...props,
    };

    // 当前第几步
    this.nowChessStep = 0;
    this.nowChessPoint = ''; // 当前棋子坐标
    this.nowChildren = [];
    this.complete = false; // 初始化情况

    this.init();
  }

  init() {
    const {
      $el, sz, width, content,
    } = this.options;
    this.mainDom = new Base({
      width,
      sz,
      content,
      $el: $el[0],
      showNum: false,
      complete: () => {
        this.completeMethod();
      },
    });
    this.nowChildren = this.mainDom.sgfParse.children;

    this.fromDom = new Resource({
      width,
      sz,
      $el: $el[1],
      showNum: false,
      LaZi: (shape, self) => {
        const chess = self.chessStep[this.nowChessStep - 1];
        this.fromDom.static.chessAudio.play();
        if (Object.keys(chess)[0].toLocaleUpperCase() === this.nowChessPoint.toLocaleUpperCase()) {
          if (this.nowChildren.length > 0) {
            this.fromDom.mianDown = true;
            setTimeout(() => {
              this.fromDom.mianDown = false;
              this.mainBranchDownChess();
            }, 1000);
          } else {
            this.options.onSuccess({
              code: 200,
              message: '打谱成功',
            });
          }
        } else {
          this.options.onError({
            code: 2,
            message: '落子错误',
          });
        }
      },
    });
  }

  completeMethod() {
    this.options.completed();
  }

  start() {
    if (this.nowChildren.length === 0) {
      // 没有棋子
      this.options.onError({
        code: 1,
        message: `给的sgf文件没有可下的棋子，请联系管理员检查文件。文件内容：${this.options.content}`,
      });
      return false;
    }
    this.mainBranchDownChess();
  }

  // 主分支下一步
  mainBranchDownChess() {
    const { data, children } = this.nowChildren[0];
    for (const item in data) {
      if (item === 'B' || item === 'W') {
        const letter = data[item][0];
        this.nowChessPoint = letter;
        this.downScoreChess(letter, item);
        this.options.ETLaZi();
        this.mainDom.stage.update();
      }
    }
    this.nowChildren = children;
  }

  // 主分支落子
  downScoreChess(v, type) {
    const { chessSpt } = this.mainDom.static;
    this.nowChessStep++;
    const num = this.mainDom.letterTurnAllNum(v);
    const sprite = new cjs.Sprite(chessSpt);
    this.mainDom.container.moreChessContainer.addChild(sprite);
    sprite.point = {
      x: num[0],
      y: num[1],
      letter: this.mainDom.numTurnAllLetter([num[0], num[1]]),
    };
    sprite.chessStep = this.nowChessStep; // 标识当前棋子在第几步
    const { x, y } = this.mainDom.calculationPoint(sprite, num[0], num[1]);
    if (type === 'B') {
      this.mainDom.drawBackChess(sprite, x, y);
    } else if (type === 'W') {
      this.mainDom.drawWhiteChess(sprite, x, y);
    }
    // 提子
    this.mainDom.tiZiMethod(num, type);
  }

  off() {
    this.mainDom.off();
    this.fromDom.off();
  }
}
